<template>
    <div style="">
       <div class="block col-md-12">
            <div class="block-title">
                <h3>Chats</h3>
            </div>

            <data-table source="/api/chats" placeholder="Search Chats">

                <template #header="{addParameter}">
                    <div class="tw-flex tw-items-center tw-justify-between sm:tw-pr-2 sm:tw-mr-2 sm:tw-border-r tw-space-x-1">
                       
                        <button @click.prevent="createChat" class="btn btn-primary"><i class="fa fa-plus"></i> New Chat</button>
                        <select name="status" class="form-control sm:tw-w-64" @input="addParameter('status', $event.target.value)">
                            <option value="">All Chats</option>
                            <option value="active">Active</option>
                            <option value="ended">Ended</option>
                        </select>
                    </div>

                </template>

                <template #columns>
                    <tr>
                        <th>Id</th>
                        <th>People</th>
                        <th>Initialize By</th>
                        <th>Subject</th>
                        <th>Status</th>
                        <th>Created At</th>
                    </tr>
                </template>

                <template #rows="{ rows }">
                    <tr v-for="chat of rows" :key="chat.id">
                        <td class="tw-m-1">{{chat.id}} </td>
                        <td class="tw-m-1">
                            <div class="tw-flex tw-flex-wrap tw-space-x-1" style="max-width: 150px">
                                
                                <div v-for="user of chat.users" :key="user.id" class="badge tw-font-semibold tw-mt-1" :style="'font-size: 10px; background-color: ' + user.color + '; color: black'">
                                    <span hidden>.</span>
                                    <div>{{user.initials}}</div>
                                </div>
                                <!-- <div>({{chat.users.length}})</div> -->
                            </div>
                        </td>
                        <td class="tw-m-1">{{chat.initializedByName}}</td>
                        <td class="tw-m-1" style="max-width: 400px">{{chat.subject.length > 50 ? chat.subject.slice(0,49) + "..." : chat.subject }}</td>
                        <td class="tw-m-1">{{chat.status}}</td>
                        <td class="tw-m-1">{{chat.createdAt}}</td>
                        <td>
                            <div class="" style="width: 78px; text-align: right" v-if="unreadMsgCounts['c' + chat.id] > 0">
                                <div class="badge label-danger">{{unreadMsgCounts['c' + chat.id]}}</div>
                            </div>
                            
                            <button class="btn btn-info tw-rounded-full tw-flex tw-items-center tw-justify-center" style="height: 30px; width: 30px;" @click="addChatToViewingChats(chat.id)">
                                <i class="gi gi-chat"></i>
                            </button>
                        </td>
                    </tr>
                </template>
            </data-table>
        </div>
        
    </div>
</template>

<script>
import Echo from 'laravel-echo';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';

export default {
    name: "ChatIndex",

    props:{
        
    },

    data() {
        return {
            unreadMsgCounts: [],
        }
    },

    mounted() {

        this.subscribeToWebsocket();
        this.getUnreadMessageCounts();
    },

    methods: {
        addChatToViewingChats(chatId){
            console.log('adding chat ' + chatId);
            
            EventBus.$emit('add-chat', chatId);
        },

        getUnreadMessageCounts(){
            axios.get('/api/chatMessages/unreadCounts')
                    .then( response => {
                        this.unreadMsgCounts = response.data;
                    });
        },

        subscribeToWebsocket(){

            // Initialize Echo - stuff copied from AccepteHosted
                window.Pusher = require('pusher-js');

                window.Echo = new Echo({
                    broadcaster: 'pusher',
                    key: 'pusher-key',
                    wsHost: window.location.hostname,
                    wsPort:6001,
                    wssPort: 6001,
                    cluster: 'mt1',
                    forceTLS: this.appEnvironment == 'production',
                    disableStats: true
                });

                window.Echo.connector.pusher.connection.bind('connected', () => {
                    console.log('connected to websocket server');
                    
                });

                window.Echo.connector.pusher.connection.bind('unavailable', () => {
                    console.log('websocket server unavailable');
                    
                });

                // From the Pusher docs:
                // Channels is not supported by the browser. This implies that WebSockets are not natively available and an HTTP-based transport could not be found.
                window.Echo.connector.pusher.connection.bind('failed', () => {
                    console.log('pusher failed');
                    
                });

                // Connection error
                window.Echo.connector.pusher.connection.bind('error', (error) => {
                    console.log('websocket connection error');
                    
                });

            console.log('in subscribeToWebsocket chatIndex');
            window.Echo.channel('alert-pia-chat-updated') 
                        .listen('AlertPIAChatUpdated', event => {
                            //console.log('There is a new chat message');
                            //console.log(event);
                            
                            this.getUnreadMessageCounts();
                        })
                        .error(error => {
                            console.error(error.message);
                            console.log('error: did not get ChatUpdated');
                        });
        },
        createChat(){
            axios.get('/chat/create')
                    .then( response => {
                        
                        let newChat = response.data;
                        this.addChatToViewingChats(newChat.id)
                    });
        }
    }
}
</script>

<style>

</style>